import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

// ✅ CORRECCIÓN 1: Definir la función con su nombre
function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: "http://localhost:3000/reset-password", // 👈 redirige al cambiar la contraseña
      });

      if (error) {
        setMessage("❌ Error al enviar el correo: " + error.message);
      } else {
        setMessage("✅ Te hemos enviado un correo para restablecer tu contraseña.");
      }
    } catch (err) {
      console.error(err);
      setMessage("Ocurrió un error inesperado.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 120px)",
        backgroundColor: "#f5f5f5",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "400px",
          width: "90%",
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "30px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          position: "relative",
        }}
      >
        {/* 🔙 Flecha para volver atrás */}
        <FaArrowLeft
          onClick={() => navigate(-1)}
          title="Volver"
          style={{
            position: "absolute",
            top: "15px",
            left: "15px",
            color: "#4B6CB7",
            fontSize: "18px",
            cursor: "pointer",
            transition: "color 0.2s ease",
          }}
          onMouseOver={(e) => (e.target.style.color = "#324b8a")}
          onMouseOut={(e) => (e.target.style.color = "#4B6CB7")}
        />

        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            fontWeight: "600",
            color: "#000",
          }}
        >
          🔑 Recuperar contraseña
        </h2>

        <form onSubmit={handleReset}>
          <input
            type="email"
            placeholder="Introduce tu correo"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: "100%",
              marginBottom: "15px",
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              outline: "none",
            }}
          />

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: "#4B6CB7",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontWeight: "500",
            }}
          >
            Enviar enlace
          </button>
        </form>

        {message && (
          <p style={{ marginTop: "20px", textAlign: "center" }}>{message}</p>
        )}

        <button
          onClick={() => navigate("/")}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "10px",
            backgroundColor: "#ccc",
            color: "black",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}

// ✅ CORRECCIÓN 2: Exportación por defecto al final
export default ForgotPasswordPage;